module.exports = require("@mui/icons-material/Highlight");